import $ from "jquery";

$(function () {
  function handleScroll() {
    if ($(window).scrollTop() > getScrollOffset()) {
      $("body").addClass("scrolled");
      $(".site-header").addClass("scrolled");
    } else {
      $("body").removeClass("scrolled");
      $(".site-header").removeClass("scrolled");
    }
  }

  function getScrollOffset() {
    return $(window).width() > 991 ? 30 : 10;
  }

  handleScroll();

  $(window).on("resize", function () {
    handleScroll();
  });

  $(window).on("scroll", function () {
    handleScroll();
  });
});
